<template>
  <div>
    <title-row
      :breadcrumb-items="[{ text: 'Átjáró riport', disabled: true }]"
      :title="'Átjáró riport'"
    >
      <template #buttons>
        <title-row-button
          v-if="elementId !== 0"
          @click="excelExport"
          :loading="isExcelExport"
          :disabled="isExcelExport"
        >
          <v-icon large>mdi-microsoft-excel</v-icon>
        </title-row-button>
      </template>
    </title-row>

    <v-expansion-panels class="mb-4 rounded-xl overflow-hidden" :value="0">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            <v-icon left>mdi-filter</v-icon>

            Szűrés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="4">
              <v-select
                label="Elem típus"
                @input="
                  elements = [];
                  accesslevels = [];
                  openings = [];
                  elementId = 0;
                  getElements();
                "
                id="elementTypeId"
                v-model="elementTypeId"
                :items="elementTypes"
                item-text="label"
                item-value="value"
              />
            </v-col>

            <v-col v-if="elements.length > 0" cols="4">
              <v-select
                label="Épület"
                @input="
                  fetchAccessLevels();
                  fetchOpenings();
                "
                id="elementId"
                v-model="elementId"
                :items="elements"
                item-text="name"
                item-value="id"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-show="elementId !== 0">
      <v-row>
        <v-col cols="8">
          <h2>Access Levels</h2>
          <v-data-table
            :headers="accessLevelHeaders"
            :items="accesslevels"
            class="elevation-1"
            item-value="access_level"
            :items-per-page="5"
          >
            <template v-slot:item.allowed="{ item }">
              <ScheduleViewer :value="item.allowed" :schedule="item.allowed_schedule" />
            </template>

            <template v-slot:item.denied="{ item }">
              <ScheduleViewer :value="item.denied" :schedule="item.denied_schedule" />
            </template>

            <template v-slot:footer.prepend>
              <v-row class="px-4">
                <v-col
                  ><strong>Egyéni jogosultságok: {{ accesslevelsSumcards }}</strong></v-col
                >
              </v-row>
            </template>
          </v-data-table>
        </v-col>

        <v-col cols="4">
          <h2>Heti nyitvatartás</h2>
          <v-data-table
            :headers="openingHeaders"
            :items="openings"
            class="elevation-1"
            item-value="day_name"
            :items-per-page="7"
          />
          <h2 class="mt-6">Jövőbeli rendhagyó nyitvatartás</h2>
          <v-data-table
            :headers="specOpeningHeaders"
            :items="openingSpecDays"
            class="elevation-1"
            item-value="date_from"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h2>Jövőbeli rendhagyó jogosultságú dátumok</h2>
          <v-data-table :headers="specDayHeaders" :items="specDays" class="elevation-1">
            <template v-slot:item.access_levels="{ item }">
              <ul style="padding-left: 0">
                <li v-for="al in item.access_levels" :key="al" style="list-style-type: none">
                  {{ al }}
                </li>
              </ul>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ScheduleViewer from '@/components/ScheduleViewer.vue';

export default {
  name: 'GatewayReport',
  components: {
    ScheduleViewer,
  },
  data() {
    return {
      elementTypes: [],
      elementTypeId: 0,
      elements: [],
      elementId: 0,
      accesslevels: [],
      openings: [],
      accesslevelsSumcards: 0,
      isExcelExport: false,
      specDays: [],
      openingSpecDays: [],
      accessLevelHeaders: [
        { text: 'Név', value: 'access_level' },
        { text: 'Engedélyezve', value: 'allowed' },
        { text: 'Tiltva', value: 'denied' },
        { text: 'Aktív kártyák', value: 'active_cards' },
      ],
      openingHeaders: [
        { text: 'Nap', value: 'day_name' },
        { text: 'Nyitás', value: 'open' },
        { text: 'Zárás', value: 'close' },
      ],
      specOpeningHeaders: [
        { text: 'Kezdő dátum', value: 'date_from' },
        { text: 'Vég dátum', value: 'date_to' },
        { text: 'Időponttól', value: 'time_from' },
        { text: 'Időpontig', value: 'time_to' },
        {
          text: 'Szabály',
          value: 'close',
          align: 'center',
          sortable: false,
          formatter: (val) => (val ? 'Zárva' : 'Nyitva'),
        },
      ],
      specDayHeaders: [
        { text: 'Megnevezés', value: 'name' },
        { text: 'Access Levels', value: 'access_levels' },
        { text: 'Kezdő dátum', value: 'start_date' },
        { text: 'Vég dátum', value: 'end_date' },
        { text: 'Időponttől', value: 'start_time' },
        { text: 'Időpontig', value: 'end_time' },
        { text: 'Szabály', value: 'operation' },
      ],
    };
  },
  methods: {
    async getElements() {
      if (this.elementTypeId === 0) {
        this.elements = [];
        return;
      }
      try {
        const response = await this.$http.post(`report/elements/${this.elementTypeId}`);
        this.elements = response.elements;
      } catch (error) {
        console.error('Error fetching elements:', error);
      }
    },
    async excelExport() {
      this.isExcelExport = true;
      if (this.elementId === 0) {
        this.isExcelExport = false;
        return;
      }
      try {
        const response = await this.$http.get(`report/export/${this.elementId}`);
        if (response.filename) {
          window.location.href =
            this.$http.defaults.baseURL + `report/download/${response.filename}`;
        }
      } catch (error) {
        console.error('Error exporting to Excel:', error);
      } finally {
        this.isExcelExport = false;
      }
    },
    async fetchInitData() {
      try {
        const response = await this.$http.get('report/init');
        this.elementTypes = response.element_types;
      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    },
    async fetchAccessLevels() {
      if (this.elementId === 0) {
        this.accesslevels = [];
        return;
      }
      try {
        const response = await this.$http.post(`report/accesslevels/${this.elementId}`);
        this.accesslevels = response.elements;
        this.accesslevelsSumcards = response.unique_cards;
        this.specDays = response.spec_days;
      } catch (error) {
        console.error('Error fetching access levels:', error);
      }
    },
    async fetchOpenings() {
      if (this.elementId === 0) {
        this.openings = [];
        return;
      }
      try {
        const response = await this.$http.get(`report/openings/${this.elementId}`);
        this.openings = response.elements;
        this.openingSpecDays = response.opening_spec_days;
      } catch (error) {
        console.error('Error fetching openings:', error);
      }
    },
  },
  mounted() {
    this.fetchInitData();
  },
};
</script>
